import React from 'react';

interface QuickResponsesProps {
  responses: string[];
  onSelect: (response: string, e: React.MouseEvent<HTMLButtonElement>) => void;
  ariaLabel?: string;
  // Space-separated ids of external elements describing the group (prompt text)
  describedBy?: string;
}

/**
 * QuickResponses component
 * Shows clickable quick response buttons. First button is filled, rest are outlined.
 * The label/description shown above the buttons is rendered by the parent ChatWindow
 * so its alignment stays consistent across all interactive control types.
 */
export const QuickResponses: React.FC<QuickResponsesProps> = ({
  responses,
  onSelect,
  ariaLabel,
  describedBy,
}) => {
  if (responses.length === 0) {
    return null;
  }

  return (
    <div
      className="omq-chatbot-quick-responses"
      role="group"
      aria-label={ariaLabel || 'Quick responses'}
      aria-describedby={describedBy}>
      {responses.map((response, index) => (
        <button
          key={index}
          className="omq-chatbot-quick-response-btn"
          onClick={(e) => onSelect(response, e)}
          type="button"
        >
          {response}
        </button>
      ))}
    </div>
  );
};
